import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ExpensesPage } from "@/features/spend/ExpensesPage";

const search = z.object({
  status: z.enum(["all", "draft", "submitted", "approved", "rejected", "reimbursed", "invoiced"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/expenses")({
  validateSearch: search,
  component: () => <ExpensesPage search={Route.useSearch()} />,
});
